 
 
import { ReactComponent as UpArrowSvg } from "../../svg/upBtn.svg";
import React, { useState, useEffect } from "react"

function UpArrow(props) {
  const [scroll, setScroll] = useState(false);
 useEffect(() => {
   window.addEventListener("scroll", () => {
     setScroll(window.scrollY > 50);
   });
 }, []);

 const scrollTop = () => {
  window.scrollTo({top: 0, behavior: "smooth"});
 }
  return (
    <div   className={scroll ? "upBtn active" : "upBtn "} onClick={scrollTop}> <UpArrowSvg/> </div>
  );
}

export default UpArrow;
